type Props = {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
};

export default function SectionHeader({ eyebrow, title, desc, align = "center" }: Props) {
  const centered = align === "center";
  return (
    <div className={`${centered ? "mx-auto text-center" : "text-left"} w-full max-w-3xl`}>
      <span
        className={`inline-flex items-center gap-2 rounded-full bg-primary-100 px-3.5 py-1 text-xs font-semibold text-primary-700 ${
          centered ? "mx-auto" : ""
        }`}
      >
        <i className="ri-sparkling-2-line text-sm" aria-hidden="true"></i>
        {eyebrow}
      </span>
      <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-900 md:text-4xl">
        {title}
      </h2>
      {desc && (
        <p className={`mt-4 text-sm leading-relaxed text-foreground-600 md:text-base ${centered ? "mx-auto" : ""}`}>
          {desc}
        </p>
      )}
    </div>
  );
}